module.exports = __webpack_public_path__ + "img/logo.81f55766.png";